"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.admin = void 0;
var adminsServiceUrl = '/admins/service';
var adminsPartnerUrl = '/admins/partner';
var qs = require('qs');
var utils_1 = require("../../utils");
// [Admin]
exports.admin = function (axios) {
    return {
        getAdminsPartner: function (request) {
            return axios.get(adminsPartnerUrl, request);
        },
        postAdminPartner: function (postAdminsPartnerRequest) {
            return axios.post(adminsPartnerUrl, postAdminsPartnerRequest.data);
        },
        getAdminsService: function (getAdminsServiceRequest) {
            return axios.get(adminsServiceUrl, getAdminsServiceRequest);
        },
        postAdminsService: function (postAdminsServiceRequest) {
            return axios.post(adminsServiceUrl, postAdminsServiceRequest.data);
        },
        deleteAdminsServiceAdminNo: function (_a) {
            var adminNo = _a.pathParams.adminNo;
            var url = adminsServiceUrl + "/" + adminNo;
            return axios.delete(url);
        },
        getAdminsPartnerAdminNo: function (getAdminsPartnerAdminNoRequest) {
            return axios.get(adminsPartnerUrl + "/" + getAdminsPartnerAdminNoRequest);
        },
        putAdminsPartnerAdminNo: function (putAdminsPartnerAdminNoRequest) {
            return axios.put(adminsPartnerUrl + "/" + putAdminsPartnerAdminNoRequest.adminNo, putAdminsPartnerAdminNoRequest.data);
        },
        deleteAdminsPartnerAdminNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete(adminsPartnerUrl + "/" + request.pathParams.adminNo + "?" + query);
        },
        postAdminsServiceCertMobile: function (postAdminsServiceCertMobileRequest) {
            return axios.post(adminsServiceUrl + "/cert/mobile", postAdminsServiceCertMobileRequest.data);
        },
        putAdminsServiceMe: function (putAdminsServiceMeRequest) {
            return axios.put(adminsServiceUrl + "/me", putAdminsServiceMeRequest.data);
        },
        putAdminsPartnerMe: function (putAdminsPartnerMeRequest) {
            return axios.put(adminsPartnerUrl + "/me", putAdminsPartnerMeRequest.data);
        },
        getGridLayouts: function (request) {
            return axios.get('/grid-layouts', request);
        },
        getGridLayoutsGridName: function (request) {
            var url = utils_1.paramPathchange('/grid-layouts/{gridName}', request);
            return axios.get(url, request);
        },
        getGridLayoutsGridNameV2: function (request) {
            var config = {
                headers: __assign(__assign({}, request.headers), { Version: '1.1' })
            };
            return axios.get("/grid-layouts/" + request.pathParams.gridName, config);
        },
        // 통합어드민 그리드 컬럼 조회
        getGridLayoutsGridNameDefault: function (request) {
            return axios.get("/grid-layouts/" + request.pathParams.gridName + "/default");
        },
        putGridLayouts: function (request) {
            return axios.put('/grid-layouts', request.data);
        },
        // 통합어드민 그리드 컬럼 수정
        putGridLayoutsGridName: function (request) {
            return axios.put("/grid-layouts/" + request.pathParams.gridName, request.data);
        },
        getAdminsServiceByAdminNo: function (request) {
            return axios.get(adminsServiceUrl + "/" + request.params.adminNo, request);
        },
        putAdminsServiceByAdminNo: function (putAdminsServiceByAdminNoRequest) {
            return axios.put(adminsServiceUrl + "/" + putAdminsServiceByAdminNoRequest.params.adminNo, putAdminsServiceByAdminNoRequest.data);
        },
        deleteAdminsServiceByAdminNo: function (request) {
            return axios.delete(adminsServiceUrl + "/" + request.params.adminNo + "?reasonDetail=" + request.params.reasonDetail);
        },
        getAdminsServiceMallAuthority: function (getAdminsServiceMallAuthorityRequest) {
            return axios.get(adminsServiceUrl + "/mall-authority", getAdminsServiceMallAuthorityRequest);
        },
        getAdminsServiceMasterTemp: function (getAdminServiceMasterTempRequest) {
            var query = qs.stringify(getAdminServiceMasterTempRequest.params);
            return axios.get(adminsServiceUrl + "/master/temp?" + query);
        },
        putAdminsServiceMasterTemp: function (putAdminServiceMasterTempRequest) {
            return axios.put(adminsServiceUrl + "/master/temp", putAdminServiceMasterTempRequest.data);
        },
        getAdminsServiceAccoutExist: function (getAdminServiceAccountExistsRequest) {
            var query = qs.stringify(getAdminServiceAccountExistsRequest.params);
            return axios.get(adminsServiceUrl + "/account/exists?" + query);
        },
        getAdminsServiceMerchandisers: function (request) {
            return axios.get('/admins/service/merchandisers', request);
        },
        getAdminsServiceAdminNo: function (request) {
            var url = utils_1.paramPathchange('/admins/service/{adminNo}', request);
            return axios.get(url, request);
        },
        getManagerInfo: function () {
            return axios.get('/managers/me');
        },
        getMallsMallNoConfigurationDeepLink: function (request) {
            return axios.get("/malls/" + request.params.mallNo + "/configuration/deep-link");
        },
        patchMallsMallNoConfigurationDeepLink: function (request) {
            return axios.patch("/malls/" + request.params.mallNo + "/configuration/deep-link", request.data);
        }
    };
};
